require('./bootstrap');

import {createApp, registerRuntimeCompiler} from "vue";
import mitt from 'mitt';
import Popper from "vue3-popper";
import LazyLoad from "vanilla-lazyload";
import { Carousel } from 'bootstrap';
import BaseRegSizeForm from './components/Partials/BaseRegSizeForm.vue';
import RegForm from './components/Partials/RegForm.vue';
import SizeForm from './components/Partials/SizeForm.vue';
import SlimlineRegSizeForm from './components/Partials/SlimlineRegSizeForm.vue';
import SlimlineRegForm from './components/Partials/SlimlineRegForm.vue';
import SlimlineSizeForm from './components/Partials/SizeForm.vue';
import Loading from './components/Partials/Loading.vue';
import CookieBanner from './components/Partials/CookieBanner.vue';
import RatingLabels from './components/Tyres/Badges/RatingLabels.vue';
import BasketSummary from './components/Basket/BasketSummary.vue';
import { initialiseAnalytics } from './analytics.js';

const analyticsPlugin = initialiseAnalytics();

if (document.getElementById('vue_app')) {
    const emitter = mitt();

    const app = createApp();

    if (analyticsPlugin !== null) {
        app.use(analyticsPlugin);
    }

    app.use(Popper);

    //Intercepting axios requests to prepend baseUrl to all requests, for proxy reasons <(^.^)>
    var baseUrlMeta = document.querySelector('meta[name="base_url"]').content.slice(0, -1);

    app.config.compilerOptions.delimiters = ["@{{", "}}"];
    app.config.globalProperties.emitter = emitter;
    app.config.globalProperties.baseUrl = baseUrlMeta;
    
    axios.interceptors.request.use(function(config) {
        config.url = baseUrlMeta + config.url;
        return config;
    });

    app.component('BaseRegSizeForm', BaseRegSizeForm)
       .component('RegForm', RegForm)
       .component('SizeForm', SizeForm)
       .component('Loading', Loading)
       .component('CookieBanner', CookieBanner)
       .component('SlimlineRegSizeForm', SlimlineRegSizeForm)
       .component('SlimlineRegForm', SlimlineRegForm)
       .component('SlimlineSizeForm', SlimlineSizeForm)
       .component('RatingLabels', RatingLabels)
       .component('BasketSummary', BasketSummary);

    app.mount("#vue_app");
}


// https://www.andreaverlicchi.eu/vanilla-lazyload/
var lazyLoadInstance = new LazyLoad();
